import React, { useEffect, useState } from 'react';
import CalendarRangeInput from './RangeInputCalendar';
import { MeasureInfoType, SelectDataType, IsValidKindOfXyCmp, GetXYDiagramData, XYDiagramSettingModel } from './XYDiagram';
import { ItemComboBox, ComboBoxItemType } from '../../atoms/ComboBox/ItemComboBox';
import ColorLineText from '../../atoms/Text/ColorLineText';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { XY_CMP_GROUP_SET } from '../../../function/GroupDataModel';
import StackCell, { CellSizeContainer } from '../../atoms/Cell/StackCell';

const useStyles = makeStyles(
  createStyles({
    labelStyle: {
      fontSize: '12px',
    },
    itemBoxStyle: {
      fontSize: '13px',
    },
  })
);

//計測種別リスト作成
const CreateDevList = (data: MeasureInfoType[]): ComboBoxItemType[] => {
  var ret: ComboBoxItemType[] = [];
  if (data != null) {
    //フィルタをして計測種別リスト作成
    var devNameList = data.filter((output) => {
      return IsValidKindOfXyCmp(output.Speed, output.KindNo);
    });

    // 重複を取り除く処理
    devNameList = devNameList.filter(
      (el: MeasureInfoType, index, self) => self.findIndex((e: MeasureInfoType) => e.DevIndex === el.DevIndex) === index
    );
    console.debug(devNameList);
    for (var i in devNameList) {
      ret.push({ index: devNameList[i].id, name: devNameList[i].DevNo + devNameList[i].DevName });
    }
  }
  return ret;
};
//計測種別リスト作成
const CreateXYList = (data: MeasureInfoType[], devId: number): ComboBoxItemType[] => {
  var ret: ComboBoxItemType[] = [];
  if (data != null) {
    var dev = data.find((item) => item.id === devId);
    var xList = data.filter((output) => {
      return IsValidKindOfXyCmp(output.Speed, output.KindNo);
    });
    console.debug(['CreateXYList', xList, data, devId, dev]);

    xList = xList.filter((r) => r.DevIndex == dev?.DevIndex);
    //console.debug(['xList 2', xList]);
    xList = xList.sort((a, b) => {
      if (a.Speed < b.Speed) return -1;
      if (a.Speed > b.Speed) return 1;
      return 0;
    });
    for (var i in xList) {
      ret.push({ index: xList[i].id, name: xList[i].ItemName });
    }
  }
  return ret;
};

type Props = {
  mesInfoList: MeasureInfoType[];
  selectData: SelectDataType;
  xyDiagramSettingModel: XYDiagramSettingModel;
  xyCmpGroupSet: XY_CMP_GROUP_SET;
  changeSelectFlg: boolean;
  onChangeSelectDataEvent: (target: SelectDataType) => void;
  onChangeSelectFlg: (target: boolean) => void;
};

const XYDiagramSelectItem: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [devList, setDevList] = React.useState<ComboBoxItemType[]>([]);
  const [xList, setXList] = React.useState<ComboBoxItemType[]>([]);
  const [yList, setYList] = React.useState<ComboBoxItemType[]>([]);
  const [selectData, setSelectData] = useState<SelectDataType>(props.selectData);
  const [colorLabel, setColorLabel] = useState<string>('■');

  const cnt = new CellSizeContainer();

  //コンボボックスデータ作成
  useEffect(() => {
    if (props.mesInfoList.length != 0) {
      var devList = CreateDevList(props.mesInfoList);
      var xList = CreateXYList(props.mesInfoList, props.selectData.devid);
      setDevList(devList);
      setXList(xList);
      setYList(xList);
      setSelectData({
        ...selectData,
        devid: props.selectData.devid,
        xid: props.selectData.xid,
        yid: props.selectData.yid,
      });
      console.debug(['devList', devList, 'xList', xList, 'props.selectData', props.selectData]);
    }
  }, [props.mesInfoList]);

  /**
   * 設定ボタン保存時に機器を更新する処理
   */
  useEffect(() => {
    if (props.changeSelectFlg) {
      setSelectData({
        ...selectData,
        devid: props.selectData.devid,
        xid: props.selectData.xid,
        yid: props.selectData.yid,
      });
    }

    console.debug(['change selectData', props.selectData]);
    props.onChangeSelectFlg(false);
  }, [props.changeSelectFlg]);

  //選択データ変更通知
  useEffect(() => {
    console.debug(['onChangeSelectDataEvent', selectData]);
    props.onChangeSelectDataEvent(selectData);
  }, [selectData]);

  //カレンダー変更イベント
  useEffect(() => {
    !(isNullOrZero(props.xyCmpGroupSet.START_MONTH1)) &&
      !(isNullOrZero(props.xyCmpGroupSet.END_MONTH1)) ?
      setColorLabel('■') :
      setColorLabel('');

  }, [props.xyCmpGroupSet]);

  /**
   * 機器変更イベント
   * @param event 
   */
  const ChangeDevSelect = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    var mes = props.mesInfoList.find((item) => item.id === Number(event.target.value));
    //console.debug([' props.mesInfoList', props.mesInfoList, ' vent.target.value', event.target.value]);
    if (mes != null) {
      var xList = CreateXYList(props.mesInfoList, mes.id);
      //console.debug(['xList', xList]);
      if (xList?.length) {
        setXList(xList);
        setYList(xList);
        if (xList.length > 1) {
          setSelectData({ ...selectData, devid: mes.id, xid: xList[1].index, yid: xList[0].index });
        } else {
          setSelectData({ ...selectData, devid: mes.id, xid: xList[0].index, yid: xList[0].index });
        }
      }
    }
  };
  /**
   * X側のアイテム変更イベント
   * @param event 
   */
  const ChangeXSelect = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    var mes = props.mesInfoList.find((item) => item.id === Number(event.target.value));
    if (mes != null) {
      setSelectData({ ...selectData, xid: mes.id });
    }
  };
  /**
   * y側のアイテム変更イベント
   * @param event 
   */
  const ChangeYSelect = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    var mes = props.mesInfoList.find((item) => item.id === Number(event.target.value));
    if (mes != null) {
      setSelectData({ ...selectData, yid: mes.id });
    }
  };

  /**
   * カレンダー変更イベント
   * @param fromDay 
   * @param toDay 
   */
  const onChangeCalenderSelectData = (fromDay: Date, toDay: Date) => {
    setSelectData({ ...selectData, fromDay: fromDay, toDay: toDay });
  };

  /**
   * nullか0を判定する関数
   * @param value 
   * @returns 
   */
  function isNullOrZero(value: number | null): boolean {
    return value === null || value === 0;
  }

  /**
   * カラーパレット
   * @param colorVaue 
   * @returns 
   */
  const handleColorChange = (colorVaue: number): string => {
    let setColR: number = colorVaue & 0xff;
    let setColG: number = colorVaue & 0xff00;
    let setColB: number = colorVaue & 0xff0000;
    console.debug(['handleColorChange', setColR, setColG, setColB])
    return `rgb(${setColR},${setColG},${setColB})`;
  };

  /**
   * 年月設定を表示
   */
  const settingItems = () => {
    let ans: JSX.Element[] = [];
    console.debug(['test settingItems', props.xyDiagramSettingModel.GraphDataItems]);
    //年：ON、月：ON
    if (props.xyDiagramSettingModel.YearFlg === 1 &&
      props.xyDiagramSettingModel.MonthFlg === 1) {
      let checkItem = '';
      //記号・年表示
      props.xyDiagramSettingModel.GraphDataItems.forEach((r) => {
        if (r.YearDateSetting !== null) {
          if (checkItem !== r.YearDateSetting.fromDate) {
            let temp = <td>
              <label className={classes.labelStyle}>
                {r.YearDateSetting.SymbolName + ':' + r.YearDateSetting.fromDate + ' ~ ' + r.YearDateSetting.toDate}
              </label>
            </td>
            checkItem = r.YearDateSetting.fromDate;
            ans.push(temp);
          }
        }
      });
      let checkColorGroupList: number[] = [0];
      //色・月表示
      props.xyDiagramSettingModel.GraphDataItems.forEach((r) => {
        if (r.ColorDataSetting.StartMonth !== 0 && r.ColorDataSetting.EndMonth !== 0) {
          let temp = <td>
            {/**ドッドのカラー表示 */}
            <ColorLineText height={'8px'} color={r.ColorDataSetting.ScatterColor} width={'8px'} />
            {/**月設定の範囲を表示 */}
            <label className={classes.labelStyle}>
              {r.ColorDataSetting.StartMonth + t('XYDiagramSelectItem.月', '月') + ' ～ ' + r.ColorDataSetting.EndMonth + t('XYDiagramSelectItem.月', '月')}
            </label>
          </td>
          if (!checkColorGroupList.find((rr) => rr === r.ColorDataSetting.ColorGroupNo)) {
            ans.push(temp);
            checkColorGroupList.push(r.ColorDataSetting.ColorGroupNo);
          }
        }
      });
    }
    //年：ON、月：OFF
    if (props.xyDiagramSettingModel.YearFlg === 1 &&
      props.xyDiagramSettingModel.MonthFlg === 0) {
      props.xyDiagramSettingModel.GraphDataItems.forEach((r) => {
        let temp = <td>
          <label className={classes.labelStyle}>
            {r.YearDateSetting.SymbolName + ':' + r.YearDateSetting.fromDate + ' ~ ' + r.YearDateSetting.toDate}
          </label>
        </td>
        ans.push(temp);
      });
    };
    //年：OFF、月：ON
    if (props.xyDiagramSettingModel.YearFlg === 0 &&
      props.xyDiagramSettingModel.MonthFlg === 1) {
      props.xyDiagramSettingModel.GraphDataItems.forEach((r) => {
        if (r.ColorDataSetting.StartMonth !== 0 && r.ColorDataSetting.EndMonth !== 0) {
          let temp = <td>
            {/**ドッドのカラー表示 */}
            <ColorLineText height={'8px'} color={r.ColorDataSetting.ScatterColor} width={'8px'} />
            {/**月設定の範囲を表示 */}
            <label className={classes.labelStyle}>
              {r.ColorDataSetting.StartMonth + t('XYDiagramSelectItem.月', '月') + ' ～ ' + r.ColorDataSetting.EndMonth + t('XYDiagramSelectItem.月', '月')}
            </label>
          </td>
          ans.push(temp);
        }
      });
    }
    return ans;
  }

  return (
    <>
      <table>
        <tr>
          <td>
            <ItemComboBox
              label={t('XYDiagramSelectItem.機器', '機器：')}
              itemList={devList}
              value={selectData.devid}
              labelStyle={classes.labelStyle}
              itemBoxStyle={classes.itemBoxStyle}
              onChangeEvent={ChangeDevSelect}
            />
          </td>
          <td>
            <ItemComboBox
              label={'X：'}
              itemList={xList}
              labelStyle={classes.labelStyle}
              itemBoxStyle={classes.itemBoxStyle}
              value={selectData.xid}
              onChangeEvent={ChangeXSelect}
            />
          </td>
          <td>
            <ItemComboBox
              label={'Y：'}
              itemList={yList}
              labelStyle={classes.labelStyle}
              itemBoxStyle={classes.itemBoxStyle}
              value={selectData.yid}
              onChangeEvent={ChangeYSelect}
            />
          </td>
          {/**年・月がOFFの場合のみ表示 */}
          {props.xyDiagramSettingModel.YearFlg === 0 && props.xyDiagramSettingModel.MonthFlg === 0 ?
            <td>
              <CalendarRangeInput
                fromDate={props.selectData.fromDay}
                toDate={props.selectData.toDay}
                onChange={onChangeCalenderSelectData}
              />
            </td>
            : null
          }
        </tr>
      </table>
      <table>
        <tr>
          <>
            {/**年表示 */}
            <label className={classes.labelStyle}>
              {t('XYDiagramSelectItem.年設定', '年設定：')}
            </label>
            <label className={classes.labelStyle}>
              {props.xyDiagramSettingModel.YearFlg === 1 ? '✔ ' : '   '}
            </label>
            {/**月表示 */}
            <label className={classes.labelStyle}>
              {t('XYDiagramSelectItem.月設定', '月設定：')}
            </label>
            <label className={classes.labelStyle}>
              {props.xyDiagramSettingModel.MonthFlg === 1 ? '✔ ' : '   '}
            </label>
            {/**年月設定 */}
            {settingItems()}
          </>
        </tr>
      </table>
    </>
  );
};

export default XYDiagramSelectItem;
